<template>
    <div class="content">
        <Form label-position="right" :label-width="200">
            <FormItem label="旧密码">
                <Input type="password" v-model="oldPwd" style="width: 300px" placeholder="请填写旧密码"></Input>
            </FormItem>
            <FormItem label="新密码">
                <Input type="password" v-model="pwd" style="width: 300px" placeholder="请填写新密码"></Input>
            </FormItem>
            <FormItem label="重新输入新密码">
                <Input type="password" v-model="testPwd" style="width: 300px" placeholder="请重新输入新密码"></Input>
            </FormItem>
            <FormItem>
                <Button type="primary" @click="changePwd">修改密码</Button>
            </FormItem>

        </Form>
    </div>
</template>
<style scoped>
.content {
    padding-top: 50px;
}
</style>
<script>
import {mapActions, mapGetters} from 'vuex'
import http from "../../libs/http.js"
export default {
    data() {
        return {
            name: '',
            oldPwd: '',
            pwd: '',
            testPwd: '',
        }
    },
    computed: {
        ...mapGetters(["getUserInfo"])
    },
    methods: {
        ...mapActions([
            'setLoginStatus'
        ]),
        changePwd() {
            console.log(this.getUserInfo)
            if (!this.oldPwd) {
                this.$Message.error('请填写旧密码')
                return
            }
            if (!this.pwd) {
                this.$Message.error('请填写新密码')
                return
            }
            if (!this.testPwd) {
                this.$Message.error('请重新输入新密码')
                return
            }
            if (!/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{8,20}$/.test(this.pwd)) {
                this.$Message.error('密码包含 数字,英文,字符中的两种以上，长度8-20')
                return
            }
            if (this.pwd != this.testPwd) {
                this.$Message.error('两次输入新密码不一致，请重新输入')
                return
            }
            let _this = this;
            http.post('/user/updatePwd', {
                id: this.getUserInfo.id,
                oldPwd: this.oldPwd,
                pwd: this.pwd
            }).then(res => {
                console.log(res)
                if (res) {
                    _this.$Message.success('密码修改成功');
                    _this.setLoginStatus({
                        status: false
                    })
                }
            }).catch(error => {
                console.log(error)
                if (error.response.status == 401) {
                    _this.$Message.error('旧密码错误')
                }else if (error.response.status == 400) {
                    _this.$Message.error('新密码不能与旧密码相同')
                }else if (error.response.status == 500) {
                    _this.$Message.error('服务器错误')
                }
            });
        }
    },
}
</script>
